import ReactGA from 'react-ga4';
import Cookies from 'js-cookie';

import { getUserId } from './ga-api';

const isProd =
  window.location.host === 'www.okcoin.jp' ||
  window.location.host === 'www.okj.com';
const TRACKING_ID_JP = isProd ? 'G-8WC751CTBJ' : 'G-413C7NRCYV';

export async function getGaUserId() {
  if (!window.utils.ont.isLogin()) return null;
  return getUserId();
}

export function setLocaleGA() {
  const locale = Cookies.get('locale');
  ReactGA.set({ dimension1: locale });
}

export async function initGA() {
  ReactGA.initialize(TRACKING_ID_JP, {
    debug: !isProd, // If you need to check console log, please set true.
    titleCase: false,
    gaOptions: {
      /** @deprecated new: https://developers.google.com/tag-platform/devguides/cross-domain?hl=ja */
      allowLinker: true,
      userId: await getGaUserId(),
      linker: {
        domains: ['www.okcoin.jp', 'www.okj.com'],
        accept_incoming: true,
      }
    },
  });
  setLocaleGA();
}
